import InquireCTA from './inquire-cta-view';

export default InquireCTA;
